<template>
  <v-card
    elevation="1"
    max-width="1080"
    class="mb-4 pa-2"
  >
    <v-card-title>
      <v-icon class="mr-2">
        mdi-filter-variant
      </v-icon> Filter
    </v-card-title>
    <v-card-text>
      <div>
        <div class="input-wrapper">
          <v-menu
            id="detection-report-filter-menu-from-date"
            v-model="menus.fromDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                id="detection-report-filter-input-from-date"
                v-model="inputs.fromDate"
                label="From Date"
                prepend-icon="mdi-calendar"
                filled
                class="input-max-width"
                :error="!isValid"
                v-on="on"
                @input="inputCallback('fromDate')"
              />
            </template>
            <v-date-picker
              id="detection-report-filter-picker-from-date"
              v-model="inputs.fromDate"
              @input="inputCallback('fromDate')"
            />
          </v-menu>
        </div>
        <div class="input-wrapper">
          <v-menu
            id="detection-report-filter-menu-from-time"
            v-model="menus.fromTime"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                id="detection-report-filter-input-from-time"
                v-model="inputs.fromTime"
                label="From Time"
                prepend-icon="mdi-clock-outline"
                filled
                class="input-max-width"
                :error="!isValid"
                v-on="on"
                @input="inputCallback('fromTime')"
              />
            </template>
            <v-time-picker
              v-if="menus.fromTime"
              id="detection-report-filter-picker-from-time"
              v-model="inputs.fromTime"
              full-width
              @click:minute="inputCallback('fromTime')"
            />
          </v-menu>
        </div>
        <div class="input-wrapper">
          <v-menu
            id="detection-report-filter-menu-to-date"
            v-model="menus.toDate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                id="detection-report-filter-input-to-date"
                v-model="inputs.toDate"
                label="To Date"
                prepend-icon="mdi-calendar"
                filled
                class="input-max-width"
                :error="!isValid"
                v-on="on"
                @input="inputCallback('toDate')"
              />
            </template>
            <v-date-picker
              id="detection-report-filter-picker-to-date"
              v-model="inputs.toDate"
              @input="inputCallback('toDate')"
            />
          </v-menu>
        </div>
        <div class="input-wrapper">
          <v-menu
            id="detection-report-filter-menu-to-time"
            v-model="menus.toTime"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                id="detection-report-filter-input-to-time"
                v-model="inputs.toTime"
                label="To Time"
                prepend-icon="mdi-clock-outline"
                filled
                class="input-max-width"
                :error="!isValid"
                v-on="on"
                @input="inputCallback('toTime')"
              />
            </template>
            <v-time-picker
              v-if="menus.toTime"
              id="detection-report-filter-picker-to-time"
              v-model="inputs.toTime"
              full-width
              @click:minute="inputCallback('toTime')"
            />
          </v-menu>
        </div>
      </div>
      <div
        v-if="!isValid"
        class="v-messages theme--light error--text"
        role="alert"
      >
        <div class="v-messages__wrapper">
          <div class="v-messages__message">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  import dateUtils from '../util/dateUtils'

  export default {
    name: 'DetectionReportFilter',

    props: {
      value: Object,
    },

    data: () => ({
      inputs: {
        fromDate: null,
        fromTime: null,
        toDate: null,
        toTime: null,
      },
      menus: {
        fromDate: false,
        fromTime: false,
        toDate: false,
        toTime: false,
      },
      isValid: true,
      errorMessage: null,
    }),

    mounted () {
      this.inputs = {
        fromDate: this.value.fromDate,
        fromTime: this.value.fromTime,
        toDate: this.value.toDate,
        toTime: this.value.toTime,
      }
      this.isValid = this.value.isValid
    },

    methods: {
      inputCallback (inputName) {
        this.menus[inputName] = false
        this.value[inputName] = this.inputs[inputName]
        this.value.isValid = this.validate()

        this.$emit('input', this.value)
      },
      validate () {
        const dateRegex = RegExp('[1-2][0-9][0-9][0-9]-[0-1][0-9]-[0-3][0-9]')
        const timeRegex = RegExp('[0-9][0-9]:[0-9][0-9]')

        if (!dateRegex.test(this.inputs.fromDate) || !dateRegex.test(this.inputs.toDate)) {
          this.isValid = false
          this.errorMessage = 'Date values in filter are not in correct format (YYYY-MM-DD)'
          return false
        }

        if (!timeRegex.test(this.inputs.fromTime) || !timeRegex.test(this.inputs.toTime)) {
          this.isValid = false
          this.errorMessage = 'Time values in filter are not in correct format (HH:MM)'
          return false
        }

        const fromTimestamp = dateUtils.getUTCTimestamp(this.inputs.fromDate, this.inputs.fromTime)
        const toTimestamp = dateUtils.getUTCTimestamp(this.inputs.toDate, this.inputs.toTime)

        if (fromTimestamp && toTimestamp) {
          if (fromTimestamp <= toTimestamp) {
            this.isValid = true
            this.errorMessage = null
            return true
          } else {
            this.isValid = false
            this.errorMessage = 'From Date must be before To date'
            return false
          }
        } else {
          this.isValid = false
          this.errorMessage = 'Date and Time values in filter are not valid'
          return false
        }
      },
    },
  }
</script>

<style scoped>
  .input-max-width {
    max-width: 250px;
  }

  .input-wrapper {
    display: inline-block;
    margin-right: 8px;
  }
</style>
